import { useTranslation } from '@/i18n';
import { IconApproval, IconCheck } from '@moneyforward/ap-frontend-components';
import { ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, useMemo } from 'react';
import { ApprovalStepStatusProps } from '../../types';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const ApprovalStepStatus: FC<ApprovalStepStatusProps> = ({ status }) => {
  const { t } = useTranslation();

  const statusLabel = useMemo(() => {
    if (
      status ===
      ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus.approved
    ) {
      return t('ap_report_status_approved');
    }

    return t('export_files_status_progress');
  }, [t, status]);

  return (
    <div
      className={cx('container', {
        'secondary-text':
          status ===
          ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus.approved,
        'success-text':
          status ===
          ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus.in_progress,
      })}
    >
      {status ===
      ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus.approved ? (
        <IconApproval size={14} />
      ) : (
        <IconCheck size={14} />
      )}
      <span>{statusLabel}</span>
    </div>
  );
};
